// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"1344d007","248":"d73a1ad9","389":"7888dcc3","404":"7690f4e5","513":"c60b0ee7","517":"db1b4ffa","666":"0fc184ef","787":"d4a90b60","793":"6c27e14c","861":"05b79ca6"}[chunkId] + ".chunk.js";
};